module.exports = __webpack_public_path__ + "img/120.6.4d3d16bd.png";